import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LabelComponent } from '../../form/label/label.component';

import { InputFieldComponent } from '../../form/input/input-field.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { SelectInputsComponent } from '../../form/form-elements/select-inputs/select-inputs.component';
import { SelectComponent } from '../../form/select/select.component';


@Component({
  selector: 'app-signup-form',
  imports: [
    CommonModule,
    LabelComponent,
    InputFieldComponent,
    RouterModule,
    FormsModule,
    SelectComponent
  ],
  templateUrl: './signup-form.component.html',
  styles: ``
})
export class SignupFormComponent {

  showPassword = false;
  isChecked = false;

  fname = '';
  lname = '';
  email = '';
  role = '';
  password = '';
  confirmPassword = '';
  phone = '';
  options = [
    // { value: 'user', label: 'user' },
    { value: 'mechanic', label: 'Mechanic' },
    { value: 'admin', label: 'Admin' },
  ];

  selectedValue = '';
  // selectedValues: string[] = ['1', '3'];

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  handleSelectChange(value: string) {
    this.selectedValue = value;
    console.log('Selected value:', value);
  }

  onSignUp() {
    console.log('First Name:', this.fname);
    console.log('Last Name:', this.lname);
    console.log('Email:', this.email);
    console.log('Password:', this.password);
    console.log('Remember Me:', this.isChecked);
  }
}
